var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-wrapper ad-header"},[_c('adsbygoogle',{attrs:{"ad-slot":"6857953552","ad-format":"horizontal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }